module.exports = __webpack_public_path__ + "static/media/agent_blackwell.2ec8a8a7.jpeg";